module.exports = __webpack_public_path__ + "static/media/PortalWeb_small.bc266e35.jpg";